class TrSlider extends HTMLElement {
	selectors = {};

	attributes = {
		config: 'data-config',
	};

	stateClasses = {};

	config = {};

	slider = null;

	connectedCallback() {
		this.init();
	}

	disconnectedCallback() {
		this.destroy();
	}

	init() {
		this.destroy();
		this.getConfig();

		if (typeof Swiper === 'undefined') return;

		this.slider = new Swiper(this, this.config);
	}

	getConfig() {
		try {
			this.config = JSON.parse(this.getAttribute(this.attributes.config)) || {};
		} catch (error) {
			console.error('Error parsing JSON:', error);
			this.config = {};
		}
	}

	destroy() {
		if (!this.slider) return;

		this.slider.destroy();

		this.slider = null;
	}
}

customElements.define('tr-slider', TrSlider);
